<template>
    <div @click="clickTypeBox" class="label-box" :class="obj.bcatacode == selectedCode ? 'selected-label-box' : ''">
        <span>{{typename}}</span>
    </div>
</template>

<script setup>
    import {inject, toRef, computed} from "vue";
    import {useUserinfo} from "@/stores/userinfo";

    const props = defineProps(["obj", "selectedCode"])
    const emits = defineEmits(["clickTypeBox"])

    const i18n = inject("i18n")
    const userInfoRef = toRef(useUserinfo())

    const typename = computed(() => {
        let name = props.obj.langen

        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
            name = props.obj.langhk
        }

        return name
    })

    function clickTypeBox() {
        emits("clickTypeBox", props.obj)
    }

</script>

<style scoped>
    .label-box {
        padding: 0 10px;
        transition: 0.5s all ease;
        color: #606266;
        font-size: 14px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        border-right: 1px #DCDFE6 solid;
        height: 100%;
    }

    .selected-label-box {
        background: #ffe0d1;
        color: #909399;
        border-right: 1px #ffe0d1 solid;

    }
</style>